<template>
  <el-scrollbar wrap-class="scrollbar-wrapper-y">
    <div>
      <div v-if="digconfig.show" class="flex">
        <span>开始时间:</span>
        <el-date-picker
          v-model="config.data.startTime"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
        <span>结束时间:</span>
        <el-date-picker v-model="config.data.endTime" type="date" placeholder="选择日期">
        </el-date-picker>
        <span>日期类型:</span>
        <el-select
          v-model="config.data.timeType"
          filterable
          reserve-keyword
          size="mini"
          placeholder="请选择日期类型"
        >
          <el-option label="逻辑日" value="逻辑日"></el-option>
          <el-option label="自然日" value="自然日"></el-option>
        </el-select>

        <el-button class="add-btn" size="mini" icon="el-icon-search" @click="flush()"
          >查询</el-button
        >
      </div>
      <div id="myChart" :style="{ width: '100%', height: digconfig.width }"></div>
    </div>
  </el-scrollbar>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      digconfig: {
        show: true,
        width: "600px",
        title: "各站数据",
        data: {},
      },
      inputwidth: 220,
      checktitle: [],
      checktype: [],
      config: {
        data: {},
      },
    };
  },
  filters: {},
  async mounted() {
    this.dateInit();
    this.flush();
  },
  methods: {
    async flush() {
      let result = await this.$http.post("/api/Analysis/SiteCount", this.config.data);
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      let option = {
        title: {
          text: "各站车辆统计",
          left: "center",
          textStyle: {
            fontSize: 30,
          },
        },
        tooltip: {},
        legend: {},
        xAxis: {
          type: "category",
          data: result.sitelist,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: result.countList,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示数值
                  position: "top", //数值在上方显示
                  textStyle: {
                    //数值样式
                    color: "black", //字体颜色
                    fontSize: 14, //字体大小
                  },
                },
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    dateInit() {
      let endDate = new Date().getTime();
      let starDate = new Date(endDate - 24 * 3600 * 1000 * 30);
      //endDate - 3600 * 1000 * 24 * 30;
      let y = starDate.getFullYear();
      let m = starDate.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = starDate.getDate();
      d = d < 10 ? "0" + d : d;
      let temptime = y + "-" + m + "-" + d;
      //debugger;
      //this.searchdata.StartTime = temptime;
      this.config.data = { startTime: temptime, timeType: "逻辑日" };
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  border-bottom: 1px solid #a8a8a8;
}
#myChart {
  margin-top: 50px;
}

.el-select > .el-input {
  width: 220px !important;
}
</style>
